import PropTypes from 'prop-types';
import React, { createContext, useState } from 'react';

export const CustomSelectContext = createContext();

export const CustomSelectContextProvider = (props) => {
  // States
  const [reset, setReset] = useState(false);
  const [resetId, setResetId] = useState(false);
  const [title, setTitle] = useState();
  const [differentStyle, setDifferentStyle] = useState(true);
  const [subTitle, setSubTitle] = useState();
  const [triggerSetValueByID, setTriggerSetValueByID] = useState(false);

  // ------------------------------------------- //
  // ----------------- Return ------------------ //
  // ------------------------------------------- //

  return (
    <CustomSelectContext.Provider
      value={{
        reset,
        title,
        subTitle,
        differentStyle,
        resetId,
        setSubTitle,
        setTitle,
        setReset,
        setDifferentStyle,
        setResetId,
        triggerSetValueByID,
        setTriggerSetValueByID,
      }}
    >
      {props.children}
    </CustomSelectContext.Provider>
  );
};

CustomSelectContextProvider.propTypes = {
  children: PropTypes.node,
};
